import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useU2000ExportExcelNotification } from '../../u2000Core/hooks/handler/U2000UseExportExcelNotification';
import { useU3204ChatStream } from '../hooks/useU3204ChatStream';
import { useU3204ConversationHandlers } from '../hooks/useU3204ConversationHandlers';
import { useU3204Context } from '../U3204Context';
import U3204ChatLayout from './U3204ChatLayout';

const U3204ChatScreen: React.FC = () => {
  const { conversationId } = useParams<{ conversationId?: string }>();
  const { activeConversationId, streamState } = useU3204Context();
  const { loadConversation, refreshActiveConversation } = useU3204ConversationHandlers();

  useU3204ChatStream();
  useU2000ExportExcelNotification();

  useEffect(() => {
    if (conversationId && conversationId !== activeConversationId) {
      void loadConversation(conversationId);
    }
  }, [conversationId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (streamState !== 'streaming' || !activeConversationId) return;

    const timer = window.setInterval(() => {
      void refreshActiveConversation();
    }, 5000);

    return () => window.clearInterval(timer);
  }, [streamState, activeConversationId, refreshActiveConversation]);

  return (
    <div className="flex h-full max-h-full min-h-0 w-full flex-1 flex-col overflow-hidden">
      <U3204ChatLayout />
    </div>
  );
};

export default U3204ChatScreen;
